import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, Validators } from '@angular/forms';

@Directive({
    selector: '[maxValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: MaxValidatorDirective, multi: true }],
    standalone: true,
})
export class MaxValidatorDirective implements Validator {
	@Input() maxValidator: number;

	validate(control: AbstractControl): { [key: string]: any } {
		return Validators.max(this.maxValidator)(control);
	}
}
